export const FILE_ACCEPTED = '.xlsx,.xls,.pdf';
export const MAX_PERCENT = 85;
